import { useMemo } from 'react';
import type { FieldError as FieldErrorType } from 'react-hook-form';
import useTranslation from '~/hooks/useTranslation';
import formStyles from '~/styles/form.module.css';

type Props = {
  error: FieldErrorType;
};

const messages = {
  required: 'form.validation.required',
  minLength: 'form.validation.minLength',
  maxLength: 'form.validation.maxLength',
  min: 'form.validation.min',
  max: 'form.validation.max',
  pattern: 'form.validation.pattern',
  validate: 'form.validation.validate',
};

export default function FieldError({ error }: Props) {
  const translate = useTranslation();

  const text = useMemo(() => {
    if (error.message) {
      return error.message;
    }

    if (typeof messages[error.type as keyof typeof messages] === 'string') {
      const key = messages[error.type as keyof typeof messages];
      const ref = error.ref as { min?: number; max?: number; pattern?: string };

      return translate(key, {
        min: ref.min ?? 0,
        max: ref.max ?? 0,
        pattern: ref.pattern ?? '',
      });
    }

    return error.type;
  }, [error, translate]);

  return (
    <div className={formStyles.formControlError} role="alert">
      {text}
    </div>
  );
}
